import React from 'react'
import {
    Text,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
} from '@salesforce/retail-react-app/app/components/shared/ui'
import PropTypes from 'prop-types'
import {CloseIcon} from '../icons/action'
import {remCalc} from '../../theme/_utils'

const GenericModal = ({isOpen, onClose, children, width}) => {
    return (
        <Modal isOpen={isOpen} onClose={onClose} blockScrollOnMount={false} isCentered>
            <ModalOverlay />
            <ModalContent
                {...{
                    maxWidth: remCalc(640),
                }}
                width={width || 'auto'}
                mx={remCalc(16)}
            >
                <ModalHeader
                    {...{position: 'absolute', top: 0, right: 0}}
                    padding={`${remCalc(40)} ${remCalc(24)}`}
                >
                    <Text></Text>
                    <CloseIcon data-testid="close-button" onClick={onClose} />
                </ModalHeader>
                <ModalBody
                    p={{
                        base: `${remCalc(40)} ${remCalc(24)} ${remCalc(24)}`,
                        md: `${remCalc(40)} ${remCalc(24)}`,
                    }}
                    data-testid="modal-body"
                >
                    {children}
                </ModalBody>
                <ModalFooter display={'none'}></ModalFooter>
            </ModalContent>
        </Modal>
    )
}

GenericModal.propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    children: PropTypes.node,
    width: PropTypes.string,
}

export default GenericModal
